export const MONTHS = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const YEARS = [2026, 2025, 2024];

export const SCORE_OPTIONS = Array.from({ length: 11 }, (_, i) => i);

export const toScale = (score) => Math.round((Number(score) || 0) / 10);

export const toBackend = (scale) =>
  Math.min(100, Math.max(0, Number(scale) || 0) * 10);

export const STATUS_STYLE = {
  active: { label: "Activo", color: "#059669", bg: "#ecfdf5" },
  inactive: { label: "Inactivo", color: "#6b7280", bg: "#f3f4f6" },
  "on-leave": { label: "En permiso", color: "#d97706", bg: "#fffbeb" },
};

/** Etiquetas de rol en contexto de evaluación */
export const EVALUATION_ROLE_LABELS = {
  admin: "Administración",
  calidad: "Calidad",
  scheduler: "Logística",
  rh: "Recursos Humanos",
};

export const EVALUATION_ROLE_COLORS = {
  admin: { color: "#f44336", bg: "#ffe6e6" },
  calidad: { color: "#0ea5e9", bg: "#e1f5fe" },
  scheduler: { color: "#f57c00", bg: "#fff4e0" },
  rh: { color: "#00897b", bg: "#e0f2f1" },
};

/**
 * Criterios de evaluación mensual por área.
 * editRoles: quién puede calificar ese criterio manualmente.
 * Cumpl. administrativo: solo admin, sin sello de evaluador.
 */
export const CRITERIA = [
  {
    id: "serviceQuality",
    field: "serviceQualityScore",
    evaluatorKey: "serviceQuality",
    label: "Calidad del servicio",
    shortLabel: "Calidad",
    color: "#6366f1",
    editRoles: ["calidad", "rh"],
  },
  {
    id: "punctuality",
    field: "punctualityScore",
    evaluatorKey: "punctuality",
    label: "Puntualidad",
    shortLabel: "Puntualidad",
    color: "#0ea5e9",
    editRoles: ["scheduler", "rh"],
  },
  {
    id: "attitude",
    field: "attitudeScore",
    evaluatorKey: "attitude",
    label: "Actitud",
    shortLabel: "Actitud",
    color: "#10b981",
    editRoles: ["scheduler", "rh"],
  },
  {
    id: "adminCompliance",
    field: "adminComplianceScore",
    evaluatorKey: "adminCompliance",
    label: "Cumplimiento administrativo",
    shortLabel: "Cumpl. Admin",
    color: "#8b5cf6",
    editRoles: ["admin"],
  },
];

export const getEvaluationRoleLabel = (role) =>
  EVALUATION_ROLE_LABELS[role] || role || "Usuario";

export const getEditableCriteria = (role) =>
  CRITERIA.filter((c) => c.editRoles.includes(role));

export const canEditCriterion = (role, criterionId) =>
  CRITERIA.find((c) => c.id === criterionId)?.editRoles.includes(role) ?? false;

/** Admin y RH ven la tabla completa con todas las calificaciones */
export const isOverviewViewer = (role) => role === "admin" || role === "rh";

export const showsEvaluatorStamp = (criterionId) => criterionId !== "adminCompliance";

export const formatEvaluator = (evaluator) => {
  if (!evaluator?.userName) return null;
  const roleLabel = getEvaluationRoleLabel(evaluator.role);
  return `${evaluator.userName} · ${roleLabel}`;
};

export const canSaveEvaluations = (role) => getEditableCriteria(role).length > 0;
